<template lang="html">
</template>

<script>
export default {

	beforeCreate(){
		this.$router.replace({ name: 'home' })
	}

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// NotFound.vue?716389bf